<template>
	<div class="work" id="design-3">
		<h2><span>03</span>Vicer</h2>
		<div class="subtitle">
			<h3><span>Year</span>2018</h3>
			<h3><span>Products</span>Logo</h3>
		</div>
		<figure>
			<img src="../../assets/logo_vicer.png" alt="Vicer App">
			<figcaption>
				<p>Vicer it's still under development, is a future App for publish sale cupons for customers that are nearby the store who is offering the promotion over some products</p>
				<p>The idea for the logo is improve this desire of consumption and showing the preference over other customers that the Vicer app promote</p>
				<p>Client team got's excited with all abstract ideas behind the symbol</p>
			</figcaption>
		</figure>
		<blockquote>
			"The Vicer app have a brilliant idea behind his service solution, re-thinking in the off-line market, i'm wish they luck!"
		</blockquote>
	</div>
</template>